"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockPage = void 0;
function mockPage(overrides = {}) {
    return {
        slug: 'home',
        hero_img: 'http://example.com/home.hero_img.9032ccef40dd538661673920b2c5101e.Feature1904.jpg',
        hero_url: '/c/soft-baits/creatures',
        hero_text: 'Creatures',
        hero_2_img: 'http://example.com/home.hero_2_img.4e540fe79867f9ff00eb9eb73e564591.hero2.jpg',
        hero_2_url: '/w/lake-calhoun?pg=1&species=walleye',
        hero_2_text: 'walleye',
        hero_3_img: 'http://example.com/home.hero_3_img.5afe9b69e184657b2435d03e3703fff2.hero3.jpg',
        hero_3_url: '/dashboard',
        hero_3_text: 'Dashboard',
        subhero_1_img: 'http://example.com/subhero1.jpg',
        subhero_1_url: '/subhero_1_url',
        subhero_1_text: 'subhero_1_url text',
        subhero_2_img: 'http://example.com/subhero2.jpg',
        subhero_2_url: '/subhero_2_url',
        subhero_2_text: 'subhero_2_url text',
        subhero_3_img: 'http://example.com/subhero3.jpg',
        subhero_3_url: '/subhero_3_url',
        subhero_3_text: 'subhero_3_url text',
        subhero_4_img: 'http://example.com/subhero4.jpg',
        subhero_4_url: '/subhero_4_url',
        subhero_4_text: 'subhero_4_url text',
        subhero_5_img: 'http://example.com/subhero5.jpg',
        subhero_5_url: '/subhero_5_url',
        subhero_5_text: 'subhero_5_url text',
        subhero_6_img: 'http://example.com/subhero6.jpg',
        subhero_6_url: '/subhero_6_url',
        subhero_6_text: 'subhero_6_url text',
        ...overrides,
    };
}
exports.mockPage = mockPage;
